<template>
  <main class="main cus_internet_mobile_create" role="main" v-if="isCompleted">
    <div class="main_con">
      <div class="m_con">
        <div class="m_title_img">
          <img
            :src="require('@/assets/front/images/new/img_internet_start_n.png')"
            alt=""
          />
        </div>
        <div class="m_title_txt">
          퍼스의 인터넷 견적 받기는 이렇게 진행돼요!
        </div>
        <div class="m_step_info">
          <div class="m_step_txt">
            <div class="txt_list_wrap">
              <div class="point on"></div>
              <div class="txt_list">
                <div class="title_txt on">1. 견적요청</div>
                <div class="txt">견적을 받기 위해 몇 가지 질문에 답하기!</div>
              </div>
            </div>
            <div class="txt_list_wrap">
              <div class="point"></div>
              <div class="txt_list">
                <div class="title_txt">2. 견적수신</div>
                <div class="txt">매장에서 보낸 견적을 확인하고 비교하기!</div>
              </div>
            </div>
            <div class="txt_list_wrap">
              <div class="point"></div>
              <div class="txt_list">
                <div class="title_txt">3. 상담진행</div>
                <div class="txt">맘에 드는 매장과 채팅 상담 시작하기!</div>
              </div>
            </div>
            <div class="txt_list_wrap">
              <div class="point last"></div>
              <div class="txt_list">
                <div class="title_txt">4. 가입신청</div>
                <div class="txt">
                  상담이 만족스러웠다면 개통을 위한 가입신청서 작성 및 접수하기!
                </div>
              </div>
            </div>
            <div class="bar"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="warning-box">
      <img
        :src="require('@/assets/front/images/new/img_txt_noti_hand.png')"
        alt=""
      />
      <div class="txt">
        <p>매장과의 직거래는 위험할 수 있습니다.</p>
        <p>직거래로 인한 문제 발생 시 전적으로 고객님 책임이 됩니다.</p>
      </div>
    </div>
    <div class="btm_btn">
      <div class="btn_wrap" @click="showShopperNotice">
        <button class="btn" :disabled="disabled">
          시작하기
        </button>
      </div>
    </div>
    <DesignPopup2
      :show="designPopup"
      :data="{
        title: '견적 받아보기 안내',
        type: 'alert',
        msg: `인터넷 견적 받아보기는 <br /> 일주일에 2회까지만 가능합니다.`,
      }"
      @close="popupClose"
    />
    <ShopperNoticePopup
      :show="isShowShopperNotice"
      @close="closeShopperNotice"
      @agree="ShopperNoticeAgree"
    />
  </main>
</template>

<script>
import DesignPopup2 from '@/common/components/modal/DesignPopup2';

import {
  mapActions as userMapActions,
  mapGetters as userMapGetters,
} from '@common/store/modules/user';
import * as userTypes from '@common/store/modules/user/types';

import {
  mapActions as internetMapActions,
  mapGetters as internetMapGetters,
} from '@common/store/modules/internet';
import * as internetTypes from '@common/store/modules/internet/types';

import format from 'date-fns/format';
import ShopperNoticePopup from '@/common/components/modal/ShopperNoticePopup.vue';

export default {
  name: 'internetCommerce_create',
  components: {
    DesignPopup2,
    ShopperNoticePopup,
  },
  data() {
    return {
      isCompleted: false,
      isMode: '', // 나의 맞는 인터넷 : MY_INTERNET, default : ''
      designPopup: false,
      disabled: true,
      isShowShopperNotice: false,
    };
  },
  async created() {
    // alert(this.$route.query.mode);
    this.isMode = this.$route.query.mode;

    localStorage.removeItem(`internetArea`);
    localStorage.removeItem(`internetEstimate`);
    localStorage.removeItem(`internetEstimateFormType`);
    localStorage.removeItem(`internetEstimateStep`);

    await this.getInternetCommerceIngList();
    await this.getInternetCommerceEndList();

    let goCreateCheck = true;
    const now = format(new Date(), 'yyyy-MM-dd HH:mm:ss');

    // 인터넷 견적을 생성한지 일주일이 지나야만 재요청이 가능하다 (최대 2건)
    if (this.internetCommerceIngList.content.length >= 2) {
      goCreateCheck = false;
    } else if (this.internetCommerceIngList.content.length == 1) {
      if (this.internetCommerceEndList.content.length >= 1) {
        const createdAt = new Date(
          this.internetCommerceEndList.content[0].createdAt,
        );

        const sDays = format(
          new Date(createdAt.setDate(createdAt.getDate() + 7)),
          'yyyy-MM-dd HH:mm:ss',
        );

        // 안지났음
        if (now < sDays) {
          goCreateCheck = false;
        } else {
          goCreateCheck = true;
        }
      } else {
        goCreateCheck = true;
      }
    } else if (this.internetCommerceIngList.content.length == 0) {
      if (this.internetCommerceEndList.content.length >= 2) {
        const createdAt_1 = new Date(
          this.internetCommerceEndList.content[0].createdAt,
        );

        const sDays_1 = format(
          new Date(createdAt_1.setDate(createdAt_1.getDate() + 7)),
          'yyyy-MM-dd HH:mm:ss',
        );

        const createdAt_2 = new Date(
          this.internetCommerceEndList.content[1].createdAt,
        );

        const sDays_2 = format(
          new Date(createdAt_2.setDate(createdAt_2.getDate() + 7)),
          'yyyy-MM-dd HH:mm:ss',
        );

        // 둘다 안지났음
        if (now < sDays_1 && now < sDays_2) {
          goCreateCheck = false;
        } else {
          goCreateCheck = true;
        }
      } else {
        goCreateCheck = true;
      }
    } else {
      goCreateCheck = true;
    }

    if (!goCreateCheck) {
      this.designPopup = true;
      this.disabled = true;
      // if (this.isMode == 'MY_INTERNET') {
      //   this.$router.go(-1);
      // } else {
      //   this.$router.push({ path: '/' }).catch(err => {});
      // }
    } else {
      this.disabled = false;
    }

    this.isCompleted = true;
  },
  // mounted() {
  // },
  computed: {
    ...userMapGetters({
      user: userTypes.USER,
    }),
    ...internetMapGetters({
      internetCommerceIngList: internetTypes.INTERNET_COMMERCE_ING_LIST,
      internetCommerceEndList: internetTypes.INTERNET_COMMERCE_END_LIST,
    }),
  },
  methods: {
    ...userMapActions([userTypes.FETCH_ME]),
    ...internetMapActions([
      internetTypes.CREATE_INTERNET_COMMERCE_ESTIMATION,
      internetTypes.SELECT_INTERNET_COMMERCE_ESTIMATION,
    ]),
    popupClose() {
      this.designPopup = false;
      this.$router.go(-1);
    },
    async getInternetCommerceIngList() {
      await this[internetTypes.SELECT_INTERNET_COMMERCE_ESTIMATION]({
        page: 1,
        size: 10,
        status: 'ING',
        orderType: 'CREATED_AT_DESC',
      });
    },
    async getInternetCommerceEndList() {
      await this[internetTypes.SELECT_INTERNET_COMMERCE_ESTIMATION]({
        page: 1,
        size: 10,
        status: 'END',
        orderType: 'CREATED_AT_DESC',
      });
    },
    gotoEstimate() {
      this.$router.push({
        name: 'InternetCommerce.RequestForm',
        query: {
          mode: this.isMode,
        },
      });
    },
    showShopperNotice() {
      this.isShowShopperNotice = true;
    },
    closeShopperNotice() {
      this.isShowShopperNotice = false;
    },
    ShopperNoticeAgree() {
      this.isShowShopperNotice = false;
      this.gotoEstimate();
    },
  },
};
</script>
